import { privateApi, publicApi } from '../config/api';

class WithdrawalService {
  // Get available withdrawal networks for a specific asset
  async getWithdrawalNetworks(currency) {
    try {
      const response = await privateApi.get(`/api/v1/withdrawal/networks/${currency}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch withdrawal networks');
    }
  }

  // Get withdrawal fees and limits for a specific asset and network
  async getWithdrawalFees(currency, network) {
    try {
      const response = await privateApi.get(`/api/v1/withdrawal/fees`, {
        params: { currency, network }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch withdrawal fees');
    }
  }

  // Create withdrawal request using the existing API endpoint
  async createWithdrawal(withdrawalData) {
    try {
      const payload = {
        currency: withdrawalData.currency,
        amount: withdrawalData.amount,
        address: withdrawalData.destination,
        tag: withdrawalData.tag || '',
        confirmation: true,//false, 
        network: withdrawalData.blockchain_currency,
        // Additional fields for the new API if needed
        sci_gate_id: withdrawalData.sci_gate_id || 0,
        data: withdrawalData.data || {},
        gate_id: withdrawalData.gate_id || 0,
        sms_code: withdrawalData.sms_code || '',
        blockchain_currency: withdrawalData.blockchain_currency || withdrawalData.currency
      };

      // Try the new API endpoint first, fallback to existing one
      try {
        const response = await privateApi.post('/api/v1/withdrawal/', payload);
        return response.data;
      } catch (newApiError) {
        // Fallback to existing API endpoint
        const response = await privateApi.post('/v1/make_withdrawal/', {
          currency: withdrawalData.currency,
          amount: withdrawalData.amount,
          address: withdrawalData.destination,
          tag: withdrawalData.tag || '',
          confirmation: false,
        });
        return response.data;
      }
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Withdrawal request failed');
    }
  }

  // Get withdrawal history
  async getWithdrawalHistory(params = {}) {
    try {
      const response = await privateApi.get('/api/v1/withdrawal/history', { params });
      return response.data;
    } catch (error) {
      // Fallback to existing endpoint
      const response = await privateApi.get('/v1/withdrawals/', { params });
      return response.data;
    }
  }

  // Validate withdrawal address
  async validateAddress(currency, address, network) {
    try {
      const response = await privateApi.post('/api/v1/withdrawal/validate-address', {
        currency,
        address,
        network
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Address validation failed');
    }
  }

  // Get withdrawal limits and requirements
  async getWithdrawalLimits(currency) {
    try {
      try {
        const response = await privateApi.get(`/api/v1/withdrawal/limits/${currency}`);
        return response.data;
      } catch (error) {
        // Fallback to existing endpoint
        const response = await privateApi.get('/v1/withdrawal_fees/');
        return response.data;
      }
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch withdrawal limits');
    }
  }

  // Confirm withdrawal (for 2FA confirmation)
  async confirmWithdrawal(withdrawalId, confirmationCode) {
    try {
      const response = await privateApi.post('/v1/confirm_withdrawal/', {
        withdrawal_id: withdrawalId,
        confirmation_code: confirmationCode,
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Withdrawal confirmation failed');
    }
  }

  // Cancel withdrawal
  async cancelWithdrawal(withdrawalId) {
    try {
      const response = await privateApi.post('/v1/cancel_withdrawal/', {
        withdrawal_id: withdrawalId,
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Withdrawal cancellation failed');
    }
  }
}

export default new WithdrawalService();
